import { registerEntityActions } from '@/actions/entityActionRegistry';
import type { EntityActionHandler } from '@/actions/entityActionRegistry';

const requireEntity = <T>(handlerId: string, entity?: T): T => {
  if (!entity) {
    throw new Error(`${handlerId} action requires an entity context.`);
  }
  return entity;
};

const viewHandler: EntityActionHandler = (context) => {
  const { entity, navigate, returnSearch } = context;
  const target = requireEntity('person.view', entity);
  if (navigate) {
    navigate(`/person/${target.id}`, { state: { returnSearch } });
  }
};

const syncHandler: EntityActionHandler = (context) => {
  const { openDialog } = context;
  if (openDialog) {
    openDialog('person.sync');
  }
};

const manageSizingHandler: EntityActionHandler = (context) => {
  const { openDialog, entity } = context;
  const target = requireEntity('person.manageSizing', entity);
  if (openDialog) {
    openDialog('person.manageSizing', { person: target });
  }
};

const bulkSizingImportHandler: EntityActionHandler = (context) => {
  const { openDialog } = context;
  if (openDialog) {
    openDialog('person.bulkSizingImport');
  }
};

registerEntityActions({
  'person.view': viewHandler,
  'person.sync': syncHandler,
  'person.manageSizing': manageSizingHandler,
  'person.bulkSizingImport': bulkSizingImportHandler,
});
